export const MAX_GROUPS_COUNT = 20;

export const ignoreDragClassName = 'ignore-drag';

export const WWWDBTODOLIST = 'WWWDBTODOLIST';
